module.exports = __webpack_public_path__ + "static/media/section1.e42bbe78.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/quiz/image/section1.png
// module id = 297
// module chunks = 0